import { Link as RouterLink, useSearchParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useAuth } from "@bw/shared/hooks";
import { AuthCard } from "../components/AuthCard";
import { AuthForm } from "../components/AuthForm";
import { useAuthRedirect } from "../hooks/useAuthRedirect";

/** Focused password-recovery request route. */
export function ForgotPasswordPage() {
  const { loading } = useAuth();
  const [searchParams] = useSearchParams();

  useAuthRedirect("/");

  const returnUrl = searchParams.get("returnUrl");
  const signInHref = returnUrl
    ? `/login?returnUrl=${encodeURIComponent(returnUrl)}`
    : "/login";

  if (loading) {
    return (
      <Stack
        aria-busy="true"
        role="status"
        spacing={1.5}
        sx={{ alignItems: "center", py: 4 }}
      >
        <CircularProgress size={28} />
        <Typography color="text.secondary">Loading…</Typography>
      </Stack>
    );
  }

  return (
    <AuthCard heading="Recover your password">
      <AuthForm mode="reset" />

      <Typography
        color="text.secondary"
        variant="body2"
        sx={{ textAlign: "center" }}
      >
        Back to{" "}
        <Link component={RouterLink} to={signInHref}>
          sign in
        </Link>
      </Typography>
    </AuthCard>
  );
}
